import React from "react";
import {
  Row,
  Col,
  Flex,
  Statistic,
  Table,
  Tag,
  Typography,
  Card,
  Space,
  Button,
  Grid, // <- added
} from "antd";
import { useNavigate } from "react-router-dom"; // <- added
import { HomeOutlined, CaretLeftOutlined } from "@ant-design/icons"; // <- added
const { Title, Text } = Typography;

// ── Component ──────────────────────────────────────────
const Dashboard = () => {
  const navigate = useNavigate(); // <- added
  const screens = Grid.useBreakpoint(); // <- added
  // screens.sm è true quando la viewport è >= sm; regola la logica come preferisci

  return (
    <Space direction="vertical" size={24} style={{ width: "100%" }}>
      <div
        style={{
          background: "white",
          minHeight: "100vh",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, #f9b27fff, #ff8c00)",
            height: "100px",
            maxHeight: "100px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(255, 106, 0, 0.3)",
            position: "relative",
          }}
        >
          <Button
            type="text"
            onClick={() => navigate("/PappaTime")}
            icon={<CaretLeftOutlined />}
            aria-label="Home"
            style={{
              position: "absolute",
              left: 16,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#fff",
              fontSize: 20,
            }}
          >
            Back
          </Button>
          <div style={{ alignItems: "center", justifyContent: "center" }}>
            <Title
              level={1}
              style={{
                color: "#fff",
                letterSpacing: "-0.4px",
              }}
            >
              Assunzione Farmaci
            </Title>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            //textAlign: "center",
            padding: "40px 16px",
            maxWidth: 1100,
            margin: "0 auto",
          }}
        >
          <div style={{ maxWidth: 900, width: "100%" }}>
            <Text
              type="secondary"
              style={{
                fontSize: 20,
                marginBottom: 12,
                color: "#333",
                textAlign: "inherit",
              }}
            >
              In questa sezione troverete alcune informazioni per un’assunzione
              di farmaci più sicura e consapevole. La letteratura scientifica
              insiste su quanto sia importante modificare la terapia
              farmacologica correttamente. Il primo consiglio è quello di
              rivolgersi al medico di riferimento, per avere indicazioni più
              accurate. Di seguito riportiamo alla vostra attenzione, riassunti
              per punti, degli accorgimenti validi prima della somministrazione
              di un qualsiasi farmaco al bambino/a: <br />
              <br />
              <span style={{ fontWeight: "bold" }}>
                “Prima di sminuzzare”:{" "}
              </span>
              è una delle pratiche più usuali ma non è applicabile a tutti i
              farmaci. Infatti alcuni, se sminuzzati o tritati, rischiano di non
              avere più un corretto dosaggio, non essere assorbiti in modo
              adeguato perché inattivati, oppure creare composti dannosi. Nel
              caso in cui il farmaco si possa polverizzare, si consiglia di
              somministrarlo insieme ad acqua gelificata, addensante, yogurt o
              purea di mela, considerando sempre la tipologia di farmaco e
              quanto indicato dal medico di riferimento. <br />
              <br />
              <span style={{ fontWeight: "bold" }}>“Non solo compresse”: </span>
              Alcuni farmaci si possono trovare in diverse formulazioni come ad
              esempio capsule, sciroppi,soluzioni orali ed altri, permettendo
              un’assunzione per os più sicura. Anche per i bambini con
              nutrizione enterale, è importante approfondire quale sia la
              formulazione più indicata, evitando così il rischio di ostruzioni
              del sondino naso gastrico e PEG, oppure che l’assorbimento avvenga
              solo in minima parte. Quindi si consiglia di rivolgersi allo
              specialista di riferimento, per un accorgimento più dettagliato.
              <br />
              <br />{" "}
              <span style={{ fontWeight: "bold" }}>
                “Occhio alla postura!”:{" "}
              </span>
              Come per il momento del pasto, è importante che il bambino/a
              assuma la terapia farmacologica, utilizzando posture o manovre di
              compenso indicate dalla logopedista. In questo modo la
              deglutizione è più sicura.
              <br />
              <br />
              <span style={{ fontWeight: "bold" }}>Bibliografia: </span>
            </Text>
            <Text
              type="secondary"
              style={{
                fontSize: 16,
                marginBottom: 12,
                color: "#333",
                textAlign: "inherit",
              }}
            >
              <br />
              -Schindler, O., Ruoppolo, G. & Schindler, A. (2011) Deglutologia.
              2° Edizione, Omega Edizioni
              <br />
              -Delgado-Silveira, E., (2023, Marzo 1) [Translated article]
              Deglufarm:Mobile application with recommendations for the safe
              administration of drugs in patients with dysphagia or swallowing
              disorders. Disponibile 25 Settembre, 2023, da
              https://www.sciencedirect.com/science/article/pii/S1130634323001095
              <br />
              -Blaszczyk, A., (2023, 19 Luglio) Crushed Tablet Administration
              for Patients with Dysphagia and Enteral Feeding: Challenges and
              Considerations. Disponibile 14 Settembre 2023, da
              https://doi.org/10.1007/s40266-023-01056-y
              <br />
              -Kunieda, K., (2020, Luglio 22) A Safe Way to Administer Drugs
              Through a Nutrition Tube—The Simple Suspension Method. Disponibile
              14 Marzo, 2021, da https://doi.org/10.1007/s00455-021-10280-w{" "}
              <br />
              -Atkin, J., (2023, 30 Luglio) Modified medication use in
              dysphagia: the effect of thickener on drug bioavailability—a
              systematic review. Disponibile 27 Gennaio, 2024, da
              https://doi.org/10.1007/s41999-023-00896-6
              <br />
              -Gotoh, Y., (2022, 19 Agosto) Yoghurt as a deglutition aid for
              oral medication: effects on famotidine powder dissolution rate and
              pharmacokinetics. Disponibile 3 Febbraio, 2023, da
              https://pmc.ncbi.nlm.nih.gov/articles/PMC9898255/
              <br />
              -Matsuo, T., (2021, 25 Novembre) Effects of yogurt as a
              deglutition aid on disintegration and dissolution of oral tablets.
              Disponibile 3 Febbraio, 2022, da
              https://pubmed.ncbi.nlm.nih.gov/35147215/
            </Text>
          </div>
        </div>
      </div>
    </Space>
  );
};

export default Dashboard;
